import React from 'react';
import { AlertTriangle, TrendingUp, DollarSign } from 'lucide-react';

const ICONS = [AlertTriangle, TrendingUp, DollarSign];
const TONES = [
  { bg: 'bg-[#FDF3E4]', text: 'text-[#B87A18]' },
  { bg: 'bg-[#FEECEF]', text: 'text-[#B71D3F]' },
  { bg: 'bg-[#FEECEF]', text: 'text-[#B71D3F]' },
];

// Tarjetas de observaciones automáticas (equivalente a la sección `.notes` del HTML de
// referencia), generadas a partir de los datos ya calculados — no texto libre del usuario.
const ObservacionesDetergentesSection = ({ observaciones }) => {
  if (!observaciones || observaciones.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {observaciones.map((obs, i) => {
        const Icon = ICONS[i % ICONS.length];
        const tone = TONES[i % TONES.length];
        return (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700/80 shadow-sm p-5 flex gap-3.5">
            <div className={`w-8 h-8 rounded-lg flex-none flex items-center justify-center ${tone.bg} ${tone.text}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div>
              <div className="font-['Manrope'] font-bold text-sm text-[#001F41] dark:text-white mb-1">{obs.titulo}</div>
              <div className="text-xs leading-relaxed text-[#43474F] dark:text-gray-400">{obs.cuerpo}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ObservacionesDetergentesSection;
